import React from 'react';
import { Users, Crown } from '@phosphor-icons/react';

const freeButtonLabel = (u, updatingUser) => {
  if (updatingUser === u._id) return '...';
  return u.is_free ? 'Remove Free' : 'Mark Free';
};

export const UserManagementTable = ({ users, updatingUser, updateUser }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-lg overflow-hidden">
    <div className="p-6 border-b border-[#E5E7EB]">
      <h2 className="font-outfit text-xl font-semibold text-[#09090B] flex items-center gap-2"><Users size={20} /> User Management</h2>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full" data-testid="admin-users-table">
        <thead>
          <tr className="border-b border-[#E5E7EB] bg-[#F9FAFB]">
            <th className="text-left px-6 py-3 text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">User</th>
            <th className="text-left px-6 py-3 text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Role</th>
            <th className="text-left px-6 py-3 text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Status</th>
            <th className="text-left px-6 py-3 text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Cases</th>
            <th className="text-right px-6 py-3 text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u._id} className="border-b border-[#E5E7EB] last:border-0 hover:bg-[#F9FAFB] transition-colors" data-testid={`admin-user-${u._id}`}>
              <td className="px-6 py-4">
                <p className="font-ibm font-semibold text-sm text-[#09090B]">{u.name}</p>
                <p className="font-ibm text-xs text-[#6B7280]">{u.email}</p>
              </td>
              <td className="px-6 py-4">
                <span className={`text-xs font-ibm font-semibold px-2 py-0.5 rounded ${u.role === 'admin' ? 'bg-purple-50 text-purple-700' : 'bg-gray-50 text-gray-700'}`}>
                  {u.role}
                </span>
              </td>
              <td className="px-6 py-4">
                {u.is_free ? (
                  <span className="text-xs font-ibm font-semibold px-2 py-0.5 rounded bg-green-50 text-green-700 flex items-center gap-1 w-fit"><Crown size={12} /> Free</span>
                ) : (
                  <span className="text-xs font-ibm text-[#6B7280]">Standard</span>
                )}
              </td>
              <td className="px-6 py-4 text-sm font-ibm text-[#09090B]">{u.cases_count || 0}</td>
              <td className="px-6 py-4 text-right">
                {u.role !== 'admin' && (
                  <div className="flex items-center gap-2 justify-end">
                    <button data-testid={`toggle-free-${u._id}`}
                      onClick={() => updateUser(u._id, { is_free: !u.is_free })}
                      disabled={updatingUser === u._id}
                      className={`px-3 py-1.5 text-xs font-ibm font-semibold rounded-md transition-all ${u.is_free ? 'bg-red-50 text-red-700 hover:bg-red-100' : 'bg-green-50 text-green-700 hover:bg-green-100'}`}>
                      {freeButtonLabel(u, updatingUser)}
                    </button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
